export default __webpack_public_path__ + "static/media/Set's Scrutiny.c6d0d053.jpg";